import { SVGProps } from 'react';

const Trophy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978m7-7.318v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978M18 9h1.5a2.5 2.5 0 0 0 0-5H18m0 5A6 6 0 1 1 6 9m12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6M4 22h16M6 9H4.5a2.5 2.5 0 1 1 0-5H6"
    />
  </svg>
);
export default Trophy;
